import { render, staticRenderFns } from "./MyChecks.vue?vue&type=template&id=543c0979&scoped=true"
import script from "./MyChecks.vue?vue&type=script&lang=js"
export * from "./MyChecks.vue?vue&type=script&lang=js"
import style0 from "./MyChecks.vue?vue&type=style&index=0&id=543c0979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c0979",
  null
  
)

export default component.exports